export const SET_SEARCH = 'pages/gerenciadorContratos/SET_SEARCH'
export const TOGGLE_SEARCH_FILTER = 'pages/gerenciadorContratos/TOGGLE_SEARCH_FILTER'
export const TOGGLE_STATUS_FILTER = 'pages/gerenciadorContratos/TOGGLE_STATUS_FILTER'
export const ADD_STATUS_FILTER = 'pages/gerenciadorContratos/ADD_STATUS_FILTER'
export const REMOVE_STATUS_FILTER = 'pages/gerenciadorContratos/REMOVE_STATUS_FILTER'
export const SET_STATUS_FILTER = 'pages/gerenciadorContratos/SET_STATUS_FILTER'
export const CLEAR_FILTERS = 'pages/gerenciadorContratos/CLEAR_FILTERS'
